import { render, staticRenderFns } from "./semi-circle.vue?vue&type=template&id=438dd14a&scoped=true"
import script from "./semi-circle.vue?vue&type=script&lang=js"
export * from "./semi-circle.vue?vue&type=script&lang=js"
import style0 from "./semi-circle.vue?vue&type=style&index=0&id=438dd14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438dd14a",
  null
  
)

export default component.exports